import { InjectionToken } from '@angular/core';
import { ApiClientConfig } from '../interfaces/api-config.interface';

/** 子工程固有の環境設定（environment）を共通ライブラリに注入するためのInjectionToken定義 */
export const API_CLIENT_CONFIG = new InjectionToken<ApiClientConfig>('API_CLIENT_CONFIG');
